import { Machine, RobotManufacturer, TeachIOMapping } from '../../robot.types';
import { AbstractManufacturerPlugin } from '../abstract-manufacturer.plugin';
import { FanucModel } from './fanuc.types';

export class FanucManufacturerPlugin extends AbstractManufacturerPlugin<FanucModel> {
  protected readonly MANUFACTURER = RobotManufacturer.FANUC;
  protected readonly MANUFACTURER_DISPLAY_NAME = 'FANUC';
  protected readonly MODELS = Object.values(FanucModel);

  public getManufacturer(): RobotManufacturer {
    return this.MANUFACTURER;
  }

  public getManufacturerDisplayName(): string {
    return this.MANUFACTURER_DISPLAY_NAME;
  }

  public getModels(): FanucModel[] {
    return this.MODELS;
  }

  public getDefaultIOMapping(_machine: Machine): TeachIOMapping {
    return {
      input: {
        capture: 'DI17',
      },
      output: {
        light: 'DO3',
      },
    };
  }
}
